import { BasicDialogProperties } from "../../../../basic/view/dialogs/BasicDialogProperties";

import { AvatarCardVO } from "../../../gamevo/AvatarCardVO";

export class Poker2TableAvatarDialogProperties extends BasicDialogProperties {
    public avatarCardVO: AvatarCardVO;
    public isGuest: boolean = false;

    constructor(avatarVO: AvatarCardVO) {
        super();

        this.isGuest = avatarVO.id < 0;
        this.avatarCardVO = avatarVO;
    }
}
